import List from "../list";
import Grid from "../grid";
import Container from "../../layouts/containers/container";
import InputsText from "../inputs/inputs-text";
import { toast } from "react-toastify";
import companiesApi from "../../lib/companies/companies-api";
import { ButtonCancel, ButtonReturn, ButtonModify, ButtonSave } from "../buttons";
import Row from "../row";
import { useState, useEffect } from "react";
import Blurred from "../blurred";

const BillingDetails = ({ booker = null, viewOnly = false }) => {
    const [ company, setCompany ] = useState(null);
    const [ billingProfile, setBillingProfile ] = useState(booker === null ? {} : booker);
    const [ billingErrors, setBillingErrors ] = useState(null);

    const [ edit, setEdit ] = useState(false);
    const [ saving, setSaving ] = useState(false);

    const fetch = () => {
        setSaving(false);
        setBillingErrors(null);
        setEdit(false);

        companiesApi.getCompany(window.user.company_id).then(({ data }) => {
            setCompany(data);
            setBillingProfile(data?.billing_profile || {});
        });
    }

    const onChange = (e) => {
        let params = { ...billingProfile }

        params[e.target.name] = e.target.value;

        setBillingProfile(params);
    }

    const updateBillingProfile = () => {
        let params = { ...billingProfile }

        const profile = Object.fromEntries(
            Object.entries(params).filter(([key, value]) => value !== null && value?.length > 0)
        );

        setSaving(true);

        companiesApi.updateBillingProfile(window?.user?.company_id, profile, (errors) => setBillingErrors(errors)).then(() => {
            toast.success("Successfully updated", {
                position: toast.POSITION.BOTTOM_CENTER
            });

            fetch();
        });
    }

    useEffect(() => {
        if (booker === null) fetch();
    }, []);

    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">{ title }</Container.Title>
                <Container.Text fontSize="16px" lightThemeColor="#24191F" darkThemeColor="#FF6933">{ value }</Container.Text>
            </List>
        )
    }

    const Flex = ({ direction, children, gap = '20px' }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: gap,
            }}>
                { children }
            </div>
        )
    }

    const profile = billingProfile;

    if (viewOnly === false && (profile === null || edit === true)) {
        return (
            
                <Container>
                    <Container.Header>
                        <List gap='10px'>
                            <Container.Text color="#FF6933" fontSize="18px">Your Billing Details</Container.Text>
                            { profile === null && <Container.Text fontSize="14px" color="#24191F">There is no billing profile set, create one</Container.Text> }
                        </List>
                    </Container.Header>

                    <Container.Content>
                        <List gap="20px">
                            <Grid columns={2} gap="20px" fill className="billing-details__edit">
                                <InputsText
                                    label="Title"
                                    name="title"
                                    onChange={onChange}
                                    value={billingProfile?.title}
                                    errors={billingErrors?.title}
                                    
                                />

                                <InputsText
                                    label="First Name"
                                    name="first_name"
                                    onChange={onChange}
                                    value={billingProfile?.first_name}
                                    errors={billingErrors?.first_name}
                                    
                                />

                                <InputsText
                                    label="Last Name"
                                    name="last_name"
                                    onChange={onChange}
                                    value={billingProfile?.last_name}
                                    errors={billingErrors?.last_name}
                                    
                                />

                                <InputsText
                                    label="Email Address"
                                    name="email_address"
                                    onChange={onChange}
                                    value={billingProfile?.email_address}
                                    errors={billingErrors?.email_address}
                                    
                                />
                                
                                <InputsText
                                    label="Address One"
                                    name="address_one"
                                    onChange={onChange}
                                    value={billingProfile?.address_one}
                                    errors={billingErrors?.address_one}
                                    
                                />

                                <InputsText
                                    label="Address Two"
                                    name="address_two"
                                    onChange={onChange}
                                    value={billingProfile?.address_two}
                                    errors={billingErrors?.address_two}
                                    
                                />

                                <InputsText
                                    label="City"
                                    name="city"
                                    onChange={onChange}
                                    value={billingProfile?.city}
                                    errors={billingErrors?.city}
                                    
                                />

                                <InputsText
                                    label="Company Name"
                                    name="company_name"
                                    onChange={onChange}
                                    value={billingProfile?.company_name}
                                    errors={billingErrors?.company_name}
                                    
                                />

                                <InputsText
                                    label="Country"
                                    name="country"
                                    onChange={onChange}
                                    value={billingProfile?.country}
                                    errors={billingErrors?.country}
                                    
                                />

                                <InputsText
                                    label="County"
                                    name="county"
                                    onChange={onChange}
                                    value={billingProfile?.county}
                                    errors={billingErrors?.county}
                                    
                                />

                                <InputsText
                                    label="Post Code"
                                    name="postcode"
                                    onChange={onChange}
                                    value={billingProfile?.postcode}
                                    errors={billingErrors?.postcode}
                                    
                                />

                                <InputsText
                                    label="Telephone Number"
                                    name="tel_no"
                                    onChange={onChange}
                                    value={billingProfile?.tel_no}
                                    errors={billingErrors?.tel_no}
                                    
                                />

                                <InputsText
                                    label="Mobile Number"
                                    name="mob_no"
                                    onChange={onChange}
                                    value={billingProfile?.mob_no}
                                    errors={billingErrors?.mob_no}
                                    
                                />

                                <InputsText
                                    label="PO Number"
                                    name="po_number"
                                    onChange={onChange}
                                    value={billingProfile?.po_number}
                                    errors={billingErrors?.po_number}
                                />
                            </Grid>

                            <Row gap="20px">
                                <ButtonSave onClick={updateBillingProfile}>Save</ButtonSave>
                                { edit === true && <ButtonReturn onClick={() => setEdit(false)}>Cancel</ButtonReturn> }
                            </Row>
                        </List>
                    </Container.Content>
                </Container>
       
        )
    }

    return (
        <Container className="billing-details">
            <Container.Header>
                <Row justifyContent="space-between">
                    <Container.Text color="#FF6933" fontSize="18px">Your Billing Details</Container.Text>
                    { viewOnly === false && <ButtonModify onClick={() => setEdit(!edit)}>Edit</ButtonModify> }
                </Row>
            </Container.Header>

            <Container.Content>
                <Flex direction="column" gap="40px 20px">
                    <Flex direction="row">
                        <Item title="First Name" value={profile?.first_name}/>
                        <Item title="Last Name" value={profile?.last_name}/>
                    </Flex>
                    <Flex direction="row">
                        <Item title="Company" value={profile?.company_name}/>
                    </Flex>
                    <Item title="Email Address" value={profile?.email_address}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={profile?.tel_no}/>
                        <Item title="Mobile Number" value={profile?.mob_no}/>
                    </Flex>
                    <Item title="SAP Number" value={profile?.sap_number}/>
                    <Item title="PO Number" value={profile?.po_number}/>
                </Flex>
            </Container.Content>
        </Container>
    )
}

export default BillingDetails;